import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./index.css";
import { FilmOutline } from "react-ionicons/lib";
import { SALE_MOVIE_PAGE } from "../../../app/routes";
// import { Badge } from "@material-ui/core";
// import { CartOutline } from "react-ionicons";
// import { useSelector } from "react-redux";
// import { State } from "../../../app/store";

const colorIcon = "var(--primary-text)";
const colorIconActive = "var(--primary-color)";
const heightIcon = "30px";
const widthIcon = "30px";
// const imageColor = "var(--primary-color)";

const MobileNavBar: React.FC = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  // const basketLength = useSelector((state: State) => state.basket.basketLength);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };
  return (
    <nav className={"navbar-mobile"}>
      <div className="navbar-logo-mobile" onClick={() => navigate(SALE_MOVIE_PAGE)}>
        <img src="https://panel.eaktywni.pl/img/1222/ciezkowice_logo23.jpg" alt={"logo"} />
      </div>
      <div className={`navbar-icon ${isOpen ? "open" : ""}`} onClick={toggleNavbar}>
        <div className={`bar ${isOpen ? "open" : ""}`}></div>
        <div className={`bar ${isOpen ? "open" : ""}`}></div>
        <div className={`bar ${isOpen ? "open" : ""}`}></div>
      </div>
      <div className={`side-menu ${isOpen ? "open" : ""}`}>
        <Link to={SALE_MOVIE_PAGE} onClick={() => setIsOpen(false)} className="mobile-navbar-item">
          <FilmOutline
            color={active === 0 ? colorIconActive : colorIcon}
            title={""}
            height={heightIcon}
            width={widthIcon}
          />
          <h3>Repertuar</h3>
        </Link>
        {/* <Link to={FINALIZE_PAGE} onClick={() => setIsOpen(false)} className="mobile-navbar-item">
          <CartOutline color={imageColor} title={"Koszyk"} height={heightIcon} width={widthIcon} />{" "}
          <h3>
            Koszyk <Badge badgeContent={basketLength} color="primary" className="mobile-navbar-item-badge"></Badge>
          </h3>
        </Link> */}
      </div>
    </nav>

    // <div className={"navbar-mobile"}>
    //   <Link to={SALE_MOVIE_PAGE} onClick={() => setActive(0)}>
    //     <FilmOutline
    //       color={active === 0 ? colorIconActive : colorIcon}
    //       title={""}
    //       height={heightIcon}
    //       width={widthIcon}
    //       cssClasses={active === 0 ? "navbar-mobile-active" : ""}
    //     />
    //   </Link>
    //   {/*<Link to={SALE_FOOD_PAGE} onClick={() => setActive(1)}>*/}
    //   {/*  <PizzaOutline*/}
    //   {/*    color={active === 1 ? colorIconActive : colorIcon}*/}
    //   {/*    title={""}*/}
    //   {/*    height={heightIcon}*/}
    //   {/*    width={widthIcon}*/}
    //   {/*    cssClasses={active === 1 ? "navbar-mobile-active" : ""}*/}
    //   {/*  />*/}
    //   {/*</Link>*/}
    //   {/*<Link to={NEWS_PAGE} onClick={() => setActive(2)}>*/}
    //   {/*  <ReaderOutline*/}
    //   {/*    color={active === 2 ? colorIconActive : colorIcon}*/}
    //   {/*    title={""}*/}
    //   {/*    height={heightIcon}*/}
    //   {/*    width={widthIcon}*/}
    //   {/*    cssClasses={active === 2 ? "navbar-mobile-active" : ""}*/}
    //   {/*  />*/}
    //   {/*</Link>*/}
    //   {/*<Link to={LOGIN_PAGE} onClick={() => setActive(3)}>*/}
    //   {/*  <PeopleOutline*/}
    //   {/*    color={active === 3 ? colorIconActive : colorIcon}*/}
    //   {/*    title={""}*/}
    //   {/*    height={heightIcon}*/}
    //   {/*    width={widthIcon}*/}
    //   {/*    cssClasses={active === 3 ? "navbar-mobile-active" : ""}*/}
    //   {/*  />*/}
    //   {/*</Link>*/}
    //   <Link to={FINALIZE_PAGE}>
    //     <Badge badgeContent={basketLength} color="primary" style={{ marginTop: -20 }}>
    //       <CartOutline color={imageColor} title={"Koszyk"} height="30px" width="30px" />
    //     </Badge>
    //   </Link>
    // </div>
  );
};

export default MobileNavBar;
